export function buildMenuTree(menuItems: any[]) {
    const map: Record<number, any> = {};
    const roots: any[] = [];

    menuItems.forEach(item => (map[item.code] = { ...item, children: [] }));

    menuItems.forEach(item => {
        const parent = map[item.parentCode];
        if (parent) {
            parent.children.push(map[item.code]);
        } else {
            roots.push(map[item.code]);
        }
    });
    roots.sort((a: any, b: any) => (a.priority ?? 0) - (b.priority ?? 0));
    roots.forEach(r => sortTree(r));
    return roots;
}

function sortTree(node: any) {
    if (node.children?.length > 0) {
        node.children.sort((a: any, b: any) => (a.priority ?? 0) - (b.priority ?? 0));
        node.children.forEach(sortTree);
    }
}
export function getAllDescendants(menuList: any[], parentCode: any): any[] {
    const result: any[] = [];
    const directChildren = menuList
        .filter((m) => m.parentCode === parentCode)
        .sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));

    for (const child of directChildren) {
        result.push(child);
        const subChildren = getAllDescendants(menuList, child.code);
        result.push(...subChildren);
    }
    return result;
}
